<template>
  <div>
    <div class="modal-title-text">{{ text }}</div>
    <TextInputMultiline
      v-model="currentMessage"
      :class="'modal-Wrapper'"
      :placeholder="
        $t(
          '_web_post_write_round-matches',
          'Write message to send to all matches in this round...'
        )
      "
      hide-label
      :rows="5"
      detect-links
      @keyup.enter.exact.stop="$emit('confirm', setMessage(currentMessage))"
      @keydown.enter.exact.prevent="newLineFix"
      @keyup.esc.prevent="$emit('cancel')"
    />
    <div class="btns-wrappers">
      <HeraFormBtn
        v-if="cancelButtonText !== false"
        class="btn-secondary-simple flex-shrink-0 flex-grow-1 col actions-btns"
        :class="cancel"
        :disabled="isLoading"
        @click.prevent="$emit('cancel')"
      >
        {{
          cancelButtonText ||
            $t('_web_stage_start_modal_confirmation_cancel', 'Cancel')
        }}
      </HeraFormBtn>
      <div
        v-if="cancelButtonText !== false && confirmButtonText !== false"
        class="spacer mx-3 px-2 col-auto"
      ></div>
      <HeraFormBtn
        v-if="confirmButtonText !== false"
        class="btn-accept-rules flex-shrink-0 flex-grow-1 col confirm-btn actions-btns"
        :loading="isLoading"
        :disabled="confirmButtonDisabled || isLoading"
        @click.prevent="$emit('confirm', setMessage(currentMessage))"
      >
        {{
          confirmButtonText ||
            $t('_web_stage_start_modal_confirmation_accept', 'Accept')
        }}
      </HeraFormBtn>
    </div>
  </div>
</template>
<script>
import HeraFormBtn from '@/components/atoms/HeraFormBtn.vue';
import TextInputMultiline from '@/components/molecules/form/TextInputMultilineWithActivators';

import { prop } from '@/utils/factories';
export default {
  name: 'SendRoundMessageModal',
  components: { HeraFormBtn, TextInputMultiline },
  props: {
    setMessage: {
      type: Function,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    textKey: {
      type: String,
      default: '',
    },
    cancelButtonText: {
      type: [String, Boolean],
      default: '',
    },
    confirmButtonText: {
      type: [String, Boolean],
      default: '',
    },
    confirmButtonDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    cancel: prop(String),
  },
  data() {
    return {
      currentMessage: '',
    };
  },
};
</script>
<style lang="scss">
.modal-Wrapper {
  .editable {
    width: 40vw !important;
    max-width: 400px !important;
  }
}
.modal-title-text {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}
.actions-btns {
  margin-top: 7px;
  margin-bottom: 7px;
}
.btns-wrappers {
  margin-top: 10px;
  display: flex;
}
</style>
